import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { StoredFilters } from 'state/SimInventory/SimInventoryStore';
import { SimInventorySegmentName } from 'types/common';

type FilterKeys = keyof StoredFilters;

interface HasUserFiltersForSegmentProps {
  segmentName: SimInventorySegmentName;
  filters?: StoredFilters;
}

const hasUserFiltersForSegment = ({ segmentName, filters }: HasUserFiltersForSegmentProps) => {
  if (!filters) {
    return false;
  }

  const filterKeys = Object.keys(filters).filter((key) => {
    const filterKey = key as keyof typeof filters;
    const filterValue = filters[filterKey];

    if (!filterValue) {
      return false;
    }

    if (isObject(filterValue)) {
      if (Object.keys(filterValue).length === 0) {
        return false;
      }
    } else if (isArray(filterValue)) {
      if (filterValue.length === 0) {
        return false;
      }
    }
    return true;
  }) as Array<FilterKeys>;

  if (filterKeys.length === 0) {
    return false;
  }

  let builtinFilters: Array<FilterKeys>;

  switch (segmentName) {
    case 'active':
    case 'deactivated':
    case 'preflight':
      builtinFilters = ['organizationId'];
      break;

    case 'all':
    default:
      builtinFilters = [];
  }

  return filterKeys.filter((filterKey) => !builtinFilters.includes(filterKey)).length > 0;
};

export default hasUserFiltersForSegment;
